import React, { useState, useEffect } from 'react';
import { Routes, Route, NavLink, useNavigate, Navigate } from 'react-router-dom';
import './App.css';
import Statistics from './components/Statistics';
import AccuracyTrends from './components/AccuracyTrends';
import About from './components/About';
import NextRound from './components/NextRound';
import Blog from './components/Blog';
import Rankings2026 from './components/Rankings2026';
import PhaseSeason2026 from './components/PhaseSeason2026';

function App() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/predictions_data.json')
      .then(response => {
        if (!response.ok) throw new Error('Failed to load predictions data');
        return response.json();
      })
      .then(data => {
        setStats(data.stats);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="App">
        <div className="loading">Loading AFL Predictions Dashboard...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1>AFL Match Predictions Dashboard</h1>
        <p className="subtitle">Next round and historical predictions with results and analysis</p>
        <p className="subtitle" style={{ fontSize: '0.85rem', marginTop: '0.5rem' }}>
          Predictions generated based on modern data science techniques
        </p>

        <nav className="view-tabs">
          <NavLink className={({ isActive }) => `tab${isActive ? ' active' : ''}`} to="/" end>
            Next Round
          </NavLink>
          <NavLink className={({ isActive }) => `tab${isActive ? ' active' : ''}`} to="/season2026">
            Season 2026
          </NavLink>
          <NavLink className={({ isActive }) => `tab${isActive ? ' active' : ''}`} to="/rankings">
            Ladder
          </NavLink>
          <NavLink className={({ isActive }) => `tab${isActive ? ' active' : ''}`} to="/statistics">
            Statistics
          </NavLink>
          <NavLink className={({ isActive }) => `tab${isActive ? ' active' : ''}`} to="/trends">
            Trends
          </NavLink>
          <NavLink className={({ isActive }) => `tab${isActive ? ' active' : ''}`} to="/about">
            About
          </NavLink>
          <NavLink className={({ isActive }) => `tab${isActive ? ' active' : ''}`} to="/blog">
            Blog
          </NavLink>
          <a
            className="tab coffee-link"
            href="https://buymeacoffee.com/footy_science"
            target="_blank"
            rel="noopener noreferrer"
          >
            ☕ Support
          </a>
        </nav>
      </header>

      <main className="App-main">
        <Routes>
          <Route path="/" element={<NextRound />} />
          <Route path="/season2026" element={<PhaseSeason2026 />} />
          <Route path="/rankings" element={<Rankings2026 />} />
          <Route path="/statistics" element={<Statistics stats={stats} />} />
          <Route path="/trends" element={<AccuracyTrends trends={stats?.accuracy_trends} />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<Blog />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <footer className="App-footer">
        <p>AFL Predictions Analysis Platform | (c) Footy Science</p>
      </footer>
    </div>
  );
}

export default App;
